import { render, staticRenderFns } from "./MyUploadStatistics.vue?vue&type=template&id=1f8bf9af&scoped=true&"
import script from "./MyUploadStatistics.vue?vue&type=script&lang=js&"
export * from "./MyUploadStatistics.vue?vue&type=script&lang=js&"
import style0 from "./MyUploadStatistics.vue?vue&type=style&index=0&id=1f8bf9af&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f8bf9af",
  null
  
)

export default component.exports